import {DataFrame} from 'data-frames/DataFrameTypes';
import * as net from 'util/Net';
import * as TaskRunner from 'util/TaskRunner';

export async function generateDatasetPreview(query: string): Promise<{dataFrame: DataFrame}> {
  return await TaskRunner.postJSONPromise({url: '/1/api/query-api-preview-async', data: {query}});
}

export async function fetchQueryApiSDL(): Promise<string> {
  // TODO (BNCH-128592): implement passing schema filters to the query-api-sdl-async endpoint
  return await TaskRunner.postJSONPromise({url: '/1/api/query-api-sdl-async', data: {}});
}

export async function fetchQueryApiBacklinks(typeName: string): Promise<{typeExtension: string | null}> {
  return await net.postJSONPromise({
    url: '/1/api/query-api-backlink-type-extension',
    data: {typeIdentifier: typeName},
  });
}
